import { useState, useEffect } from "react";
import { string, object, func } from "prop-types";
import NarrativeLinks from "../NarrativeLinks/NarrativeLinks.jsx";
import cx from "classnames";
import useClickAway from "../../common/useClickAway.js";
import Toolbar from "../Toolbar/Toolbar.jsx";

const propTypes = {
  contentsHeader: string,
  narrativeTitle: string,
  sectionTitle: string,
  navItems: object,
  pageInfo: object,
  toolbarDictionary: object,
  toolbarOptions: object,
  toolbarPdf: object,
  setDraftReport: func,
};

const NarrativeSubmenu = (props) => {
  const {
    contentsHeader,
    narrativeTitle,
    sectionTitle,
    navItems,
    pageInfo,
    toolbarDictionary,
    toolbarOptions,
    toolbarPdf,
    setDraftReport,
  } = props;

  const [isBarPersistent, setBarPersistent] = useState(false);
  const [isBarVisible, setBarVisibility] = useState(false);
  const [isMenuOpen, setOpen] = useState(false);

  const narrativeSubmenuRef = useClickAway({ isOpen: isMenuOpen, setOpen });

  useEffect(() => {
    const narrativeContents = document.querySelector(".js-narrative-contents");

    if (narrativeContents) {
      const toggleNarrativeSubmenu = (event) => {
        if (
          window.pageYOffset > narrativeContents.getBoundingClientRect().bottom
        ) {
          setBarVisibility(true);
        } else {
          setBarVisibility(false);
          setOpen(false);
        }
      };
      window.addEventListener("scroll", toggleNarrativeSubmenu);
      return () => {
        window.removeEventListener("scroll", toggleNarrativeSubmenu);
      };
    } else {
      // if we do'nt have a narrativeContents, always show
      setBarPersistent(true);
    }
  }, []);

  return (
    <section
      className={cx("narrative-submenu", {
        "narrative-submenu--visible": isBarVisible,
        "narrative-submenu--persistent": isBarPersistent,
        "narrative-submenu--open": isMenuOpen,
      })}
    >
      <div className="narrative-submenu__container container container--100">
        <div className="narrative-submenu__info-bar">
          <button
            onClick={() => setOpen((open) => !open)}
            className="narrative-submenu__trigger"
            type="button"
          >
            <svg
              className="narrative-submenu__hamburger icon--24x24"
              style={{ paddingRight: "15px" }}
              width="22"
              height="16"
              viewBox="0 0 22 16"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g transform="translate(0 .5)" fillRule="nonzero" fill="none">
                <path
                  stroke="#0098A7"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  d="M7 1.5h14M7 7.5h14M7 13.5h14"
                />
                <circle fill="#0098A7" cx="1.5" cy="1.5" r="1.5" />
                <circle fill="#0098A7" cx="1.5" cy="7.5" r="1.5" />
                <circle fill="#0098A7" cx="1.5" cy="13.5" r="1.5" />
              </g>
            </svg>
            <span className="narrative-submenu__trigger-text">
              {contentsHeader}
            </span>
          </button>
          <h2 className="narrative-submenu__title">{narrativeTitle}</h2>
          <span className="narrative-submenu__active-page">{sectionTitle}</span>
          <Toolbar
            setDraftReport={setDraftReport}
            pageInfo={pageInfo}
            toolbarDictionary={toolbarDictionary}
            toolbarOptions={toolbarOptions}
            toolbarPdf={toolbarPdf}
          />
          <span style={{ display: "none" }}>toolbar-here</span>
        </div>
      </div>
      <div ref={narrativeSubmenuRef} className="narrative-submenu__menu">
        <div className="container container--100">
          <div className="narrative-submenu__menu-title-container">
            <h2 className="narrative-submenu__menu-title">{narrativeTitle}</h2>
            <button
              onClick={() => setOpen((open) => !open)}
              className="narrative-submenu__close"
              type="button"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="feather feather-x"
              >
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>
          </div>
          <NarrativeLinks
            className="narrative-submenu__narrative-links"
            {...navItems}
          />
        </div>
      </div>
    </section>
  );
};

NarrativeSubmenu.propTypes = propTypes;
export default NarrativeSubmenu;
